<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thêm mới danh mục slider</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Tên danh mục sliders:"
                  label-for="name"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="name"
                    class="col-6"
                    aria-describedby="codeFeedback"
                    v-model="$v.sliderVideoType.name.$model"
                    :state="
                      $v.sliderVideoType.name.$dirty
                        ? !$v.sliderVideoType.name.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tên danh mục slider
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Mã danh mục sliders:"
                  label-for="code"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                  label-class="required"
                >
                  <b-form-input
                    type="text"
                    id="code"
                    class="col-6"
                    aria-describedby="codeFeedback"
                    v-model="$v.sliderVideoType.slug.$model"
                    :state="
                      $v.sliderVideoType.slug.$dirty
                        ? !$v.sliderVideoType.slug.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập mã danh mục slider
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Thứ tự hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="4"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-6"
                    v-model="sliderVideoType.orderDisplay"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="4">
                  <b-button
                    v-if="authorize(['ManageSliderVideoType'])"
                    type="submit"
                    variant="primary"
                    >Ghi lại</b-button
                  >
                  <b-button type="button" variant="secondary" @click="cancel"
                    >Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { authorizationMixin } from "@/shared/mixins";
import {
  required,
  sameAs,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";

export default {
  name: "CreatesliderVideoType",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      codeUnique: "ok",
      sliderVideoType: {
        name: null,
        slug: null,
        orderDisplay: null
      },
      editing: false,
    };
  },
  computed: {},
  validations: {
    sliderVideoType: {
      name: {
        required,
        maxLength: maxLength(512),
      },
      slug: {
        required,
        maxLength: maxLength(512),
      },
    },
  },
  watch: {
    "sliderVideoType.name"(value) {
      this.sliderVideoType.slug = value.convertslug();
    },
  },
  created() {},
  methods: {
    cancel() {
      this.$router.push({ path: "/system/slider-video-types/list" });
    },
    save() {
      this.$v.$touch();
      var vm = this;
      if (!this.$v.$invalid) {
        this.$services
          .post("system/slider-video-types", this.sliderVideoType)
          .done((id) => {
            vm.$toastr.s("Tạo mới danh mục slider thành công");
            vm.cancel();
          });
      }
    },

    //checkExistCode(newVal) {
    //    if (newVal) {
    //        //var vm = this;
    //        //this.$services.get(`system/existing-unit-types-code/${newVal}/${this.sliderVideoType.id || null}`).done(returnData => {
    //        //    if (!returnData) {
    //        //        this.codeUnique = "required";
    //        //    }
    //        //    else {
    //        //        this.codeUnique = "";
    //        //    }
    //        //});
    //    }
    //    else {
    //        this.codeUnique = "required";
    //    }
    //}
  },
};
</script>
<style scoped>
</style>
